import { put, call, fork, join, delay } from 'redux-saga/effects'

import * as types from '../actions/actionTypes'
import {
  setSnackbarAction,
  setSnackbarErrorAction,
} from '../actions/snackbarActions'
import { resetWithdrawToListAction } from '../actions/withdrawAction'
import * as api from '../api'
import { getErrorMessage } from '../domain/Errno'
import { attemptRefreshToken } from './userSaga'

export function* calculateWithdrawSaga({ payload }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    const res = yield call(api.requestWithdrawInfo, payload.amount)
    yield put({
      type: types.CALCULATE_WITHDRAW_SUCCESS,
      payload: res.data,
    })
  } catch (err) {
    console.error('calculateWithdrawSaga', err)
    const message = getErrorMessage(err)
    yield put({ type: types.CALCULATE_WITHDRAW_ERROR })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}

/*
  payload: {
    "withdraw_amount": 7500, // 提領金額(台幣)
    "withdraw_fee_source": 351, // 服務費(台幣)
    "handling_fee_source": 35, // 金流處理費(台幣)
    "calc_withdraw_amount_source": 7114 // 實領金額(台幣)
  }
 */
export function* makeWithdrawSaga({ payload }) {
  try {
    yield put({ type: types.FETCHING })
    const refreshTokenTask = yield fork(attemptRefreshToken)
    yield join(refreshTokenTask)

    const { data } = yield call(api.requestCreateWithdraw, payload)
    yield put({
      type: types.MAKE_WITHDRAW_SUCCESS,
      payload: data,
    })

    yield put({ type: types.FETCH_COMPLETE })

    yield delay(100)

    yield put(
      setSnackbarAction({
        content: '提領申請成功',
        color: 'black',
      }),
    )

    // * push animation
    yield put(resetWithdrawToListAction(data))

    yield delay(1000)

    // * mark item animation as finished, so animation won't show again
    yield put({ type: types.MARK_WITHDRAW_SHOWN })
  } catch (err) {
    console.error('makeWithdrawSaga', err)
    const message = getErrorMessage(err)
    yield put({ type: types.MAKE_WITHDRAW_ERROR })
    yield put(setSnackbarErrorAction(message))
  } finally {
    yield put({ type: types.FETCH_COMPLETE })
  }
}
